import React from 'react';
import { GenericListPage } from '../../components/generic';
import { useWorkflows, Workflow } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const useWorkflowsList = (searchParams?: string) => {
    const { data, isLoading, mutate } = useWorkflows(false);
    return { data, isLoading, mutate };
  };

  return (
    <GenericListPage<Workflow>
      useData={useWorkflowsList}
      config={{
        ...moduleConfig,
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
    />
  );
};

export default List;
